// extracted by mini-css-extract-plugin
export default {"mega_loading_wrapper":"megaLoading_mega_loading_wrapper__Xr29G","mega_loading":"megaLoading_mega_loading__Q39hF"};